<template>
  <v-container fluid class="pa-0">

    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <v-img
            :src="setHomeScreen(1)"
            :lazy-src="setHomeScreenMin(1)"
            width="100%"
            min-height="750px"
        >
        </v-img>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-10">
      <v-col cols="auto" class="pb-0">
        <span class="new-collection clickable-cursor" @click="navigate('/positanocoutureforblitzSS23')"><strong>{{$t("homepage.newCollections")}}</strong></span>
      </v-col>
    </v-row>

    <v-row justify="center" class="ma-0 pa-0">
      <v-col cols="auto" class="pa-0">
        <v-btn v-if="!isMobile()" text to="/positanocoutureforblitzSS23" class="pa-2 mb-1" style="font-size: 18px">{{$t('homepage.clickHere')}}</v-btn>
        <v-btn v-else text large to="/positanocoutureforblitzSS23" class="pa-0 px-2 mb-1" style="font-size: 16px">{{$t('homepage.clickHere')}}</v-btn>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2">
      <v-col cols="12" class="pa-0">
        <v-img
            :src="require('../assets/home/image00001-raw.jpg')"
            :lazy-src="require('../assets/home/image00001-min.jpg')"
            min-height="750px"
            @click="navigateFromImage('/positanocoutureforblitzSS23')"
            class="clickable-cursor zoom"
        >
        </v-img>
      </v-col>
    </v-row>

    <!--<v-row justify="center" class="mt-10">
      <v-col cols="auto" class="pb-0">
        <span class="new-collection"><strong>{{$t("homepage.newCollections")}}</strong></span>
      </v-col>
    </v-row>-->

    <!--
    <v-row justify="space-around" class="ma-0 pa-0">
      <v-col xl="6" lg="6" md="6" sm="12" class="ma-0 pa-6">
        <v-btn v-if="!isMobile()" text to="/blitzSS22" class="pa-0 mb-3" style="font-size: 18px">{{$t('homepage.blitzButton')}}</v-btn>
        <v-btn v-else text outlined elevation="1" large to="/blitzSS22" class="pa-0 mb-3" style="font-size: 17px">{{$t('homepage.blitzButton')}}</v-btn>
        <v-img
                :src="require('../assets/home/central_blitz.jpg')"
                :lazy-src="require('../assets/home/central_blitz-min.jpg')"
                width="100%"
                :height="setHeightCentralCol()"
                @click="navigateFromImage('/blitzSS22')"
                class="clickable-cursor zoom"
        >

        </v-img>
      </v-col>
      <v-col xl="6" lg="6" md="6" sm="12" class="ma-0 pa-6 text-left">
        <v-btn v-if="!isMobile()" text to="/positanocoutureSS22" class="pa-0 mb-3" style="font-size: 18px"> {{$t('homepage.positanoCotureButton')}}</v-btn>
        <v-btn v-else text outlined elevation="1" large to="/positanocoutureSS22" class="pa-0 mb-3" style="font-size: 17px"> {{$t('homepage.positanoCotureButton')}}</v-btn>
        <v-img
                :src="require('../assets/home/central_couture.jpg')"
                :lazy-src="require('../assets/home/central_couture-min.jpg')"
                width="100%"
                :height="setHeightCentralCol()"
                @click="navigateFromImage('/positanocoutureSS22')"
                class="clickable-cursor zoom"
        >
        </v-img>
      </v-col>
    </v-row>
  -->

    <v-row class="ma-0 mt-5 pa-0">
      <v-col class="ma-0 pa-0">
        <v-img
            :src="setHomeScreen(2)"
            :lazy-src="setHomeScreenMin(2)"
            width="100%"
            min-height="750px"
        >
          <v-container class="fill-height">
            <v-row justify="start">
              <v-col align="center" cols="5" class="">
                <h1>
                  {{$t("homepage.collection2021")}}
                </h1>
                <!--<p class="mb-3">
                  {{$t("homepage.collectionSpringSummer")}}
                </p>-->
                <v-btn rounded elevation="3" to="/adv">
                  {{$t("homepage.findOut")}}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
            </v-row>
          </v-container>
        </v-img>
      </v-col>
    </v-row>

    <v-row justify="space-around" class="ma-0 pa-0">
      <v-col xl="6" lg="6" md="6" sm="12" class="ma-0 pa-5">
        <v-img
                :src="require('../assets/home/_DSC8024.jpg')"
                :lazy-src="require('../assets/home/_DSC8024-min.jpg')"
                width="100%"
                min-height="750px"
                style=""
        >
          <v-container dark class="fill-height white--text">
            <v-row justify="center" align="center">
              <v-col align="center" cols="12" class="pt-2">
                <v-btn rounded large elevation="3" to="/ourstory" class="button">
                  {{$t('homepage.ourBrand')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-img>
      </v-col>
      <v-col xl="6" lg="6" md="6" sm="12" class="ma-0 pa-5">
        <v-img
                :src="require('../assets/home/_DSC7443.jpg')"
                :lazy-src="require('../assets/home/_DSC7443-min.jpg')"
                width="100%"
                min-height="750px"
                style=""
        >
          <v-container dark class="fill-height white--text">
            <v-row justify="center" align="center">
              <v-col align="center" cols="12" class="pt-2">
                <v-btn rounded large elevation="3" to="/menscollection">
                  {{$t('homepage.mensCollection')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

        </v-img>
      </v-col>
    </v-row>

    <!--
    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <v-img
                :src="require('../assets/home/_DSC8024.jpg')"
                :lazy-src="require('../assets/home/_DSC8024-min.jpg')"
                width="100%"
                height="750px"
                style=""
        >
          <v-container class="fill-height">
            <v-row justify="start">
              <v-col align="center" cols="5">
                <h1>
                  {{$t("homepage.ourBrand")}}
                </h1>
                <p class="mb-3">
                  {{$t("homepage.ourBrandDescription")}}
                </p>
                <v-btn rounded outlined elevation="3" to="/ourstory">
                  {{$t("homepage.ourBrandButton")}}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
            </v-row>
          </v-container>
        </v-img>
      </v-col>
    </v-row>

    <v-row v-if="!isMobile()" class="ma-0 pa-0">
      <v-col class="ma-0 pa-5">
        <v-img
                :src="require('../assets/home/image00013-14.jpg')"
                :lazy-src="require('../assets/home/image00013-14-min.jpg')"
                width="100%"
                height="750px"
                style=""
        >
          <v-container class="fill-height">
            <v-row justify="center" align="center">
              <v-col align="center" cols="12">
                <v-btn rounded large elevation="3" to="/menscollection" class="button">
                  {{$t('homepage.mensCollection')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-img>
      </v-col>
    </v-row>

    <v-row v-if="isMobile()" justify="center" class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pr-0">
        <v-img
                :src="require('../assets/home/image00013.jpeg')"
                :lazy-src="require('../assets/home/image00013-min.jpeg')"
                width="100%"
                :height="setHeightCentralCol()"
                style=""
        >
        </v-img>
      </v-col>
      <v-col cols="auto">
        <v-btn rounded large elevation="3" to="/menscollection" class="button">
          {{$t('homepage.mensCollection')}}
        </v-btn>
      </v-col>
      <v-col cols="12" class="ma-0 pl-0">
        <v-img
                :src="require('../assets/home/image00014.jpeg')"
                :lazy-src="require('../assets/home/image00014-min.jpeg')"
                width="100%"
                :height="setHeightCentralCol()"
                style=""
        >
        </v-img>
      </v-col>
    </v-row>
    -->

  </v-container>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },

  methods:{
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    setHeightCentralCol() {
      if(this.isMobile()){
        return "550px"
      } else {
        return "790px"
      }
    },
    setHomeScreen(i){
      if(this.isMobile()){
        if(i == 1) return require('../assets/home/_DSC7772.jpg')
        if(i == 2) return require('../assets/home/_DSC7469-mobileVersion.jpg')
      } else {
        if(i == 1) return require('../assets/home/_DSC7772.jpg')
        if(i == 2) return require('../assets/home/_DSC7469.jpg')
      }
    },
    setHomeScreenMin(i){
      if(this.isMobile()){
        if(i == 1) return require('../assets/home/_DSC7772-min-min.jpg')
        if(i == 2) return require('../assets/home/_DSC7469-mobileVersion-min.jpg')
      } else {
        if(i == 1) return require('../assets/home/_DSC7772-min-min.jpg')
        if(i == 2) return require('../assets/home/_DSC7469-min.jpg')
      }
    },
    navigate(path){
      if(this.$router.currentRoute.path !== path) {
        this.$router.push(path)
      }
    },
    navigateFromImage(path){
      if(!this.isMobile()){
        if(this.$router.currentRoute.path !== path) {
          this.$router.push(path)
        }
      }
    },
  }
}
</script>

<style scoped>

  .button:hover {
    background-color: white;
    color: black;
  }

  .image-caption {
    background: rgba(255,255,255,.6);
  }

  .wrap {
    z-index: 3;
    text-align: center;
  }

  .new-collection {
    #background-color: #191919 !important;
    background-color: orange;
    -webkit-animation-name: example; /* Chrome, Safari, Opera */
    -webkit-animation-duration: 2s; /* Chrome, Safari, Opera */
    animation-name: example;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    border: none;
    color: white !important;
    padding: 5px 40px;
    text-align: center;
    text-decoration: none !important;
    font-size: 30px;
  }

  /* Chrome, Safari, Opera */
  @-webkit-keyframes example {
    0%   {background-color: grey;}
    50%  {background-color: dimgray;}
    100%  {background-color: black;}
  }

  /* Standard syntax */
  @keyframes example {
    0%   {background-color: grey;}
    50%  {background-color: dimgray;}
    100%  {background-color: black;}
  }

  .clickable-cursor{
    cursor: pointer !important;
  }

  .zoom:hover {
    transform: scale(1.01); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  }

</style>
